import { stripOidcLandQueryParam } from '../session/returnTarget.js';
import { unwrapNonRecoveryReturnTo } from './captureRecoveryReturnTo.js';
import type { RecoveryQueryContext } from './types.js';

export function buildRecoveryPath(
  tenantCode: string,
  classSlug: string,
  context?: RecoveryQueryContext,
): string {
  const base = `/${encodeURIComponent(tenantCode)}/recovery/${encodeURIComponent(classSlug)}`;
  const params = new URLSearchParams();
  if (context?.returnTo !== undefined && context.returnTo.length > 0) {
    // Strip oidcLand + peel nested recovery returnTo so resume never loops recovery→recovery.
    const safeReturnTo = unwrapNonRecoveryReturnTo(
      stripOidcLandQueryParam(context.returnTo),
    );
    if (safeReturnTo !== undefined) {
      params.set('returnTo', safeReturnTo);
    }
  }
  if (context?.paymentId !== undefined && context.paymentId.length > 0) {
    params.set('paymentId', context.paymentId);
  }
  if (context?.journey !== undefined && context.journey.length > 0) {
    params.set('journey', context.journey);
  }
  const query = params.toString();
  return query.length > 0 ? `${base}?${query}` : base;
}

export function readRecoveryQueryContext(search: string): RecoveryQueryContext {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const returnToRaw = params.get('returnTo');
  const returnTo =
    returnToRaw !== null && returnToRaw.length > 0
      ? unwrapNonRecoveryReturnTo(stripOidcLandQueryParam(returnToRaw))
      : undefined;
  const paymentId = params.get('paymentId');
  const journey = params.get('journey');
  return {
    ...(returnTo !== undefined ? { returnTo } : {}),
    ...(paymentId !== null && paymentId.length > 0 ? { paymentId } : {}),
    ...(journey !== null && journey.length > 0 ? { journey } : {}),
  };
}
